import { useQuery } from '@tanstack/react-query'
import { getDayforceWebhook } from 'api/admin/dayforce/getDayforceWebhook'
import { dayforceKeys } from './keys'

export const useDayforceWebhookDetailQuery = (webhookId: number) => {
  return useQuery({
    queryKey: dayforceKeys.webhookDetail(webhookId),
    queryFn: () => getDayforceWebhook(webhookId),
    enabled: Number.isFinite(webhookId) && webhookId > 0,
  })
}
